module.exports = __webpack_public_path__ + "static/media/aerial.11625c2e.jpg";